var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueCustomTooltip',{class:_vm.className ? `vue-custom-tooltip-text ${_vm.className}` : 'vue-custom-tooltip-text',attrs:{"label":_vm.text,"sticky":false,"multiline":true}},[_c('span',{staticClass:"material-symbols-outlined"},[_vm._v(" help ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }